import React from 'react';
import { arrowUp, arrowDown } from './arrows';

export default ({ shortName, longName, showUpArrow, showDownArrow }) => {
    return (
        <div>
            <div className="multi-currency-item">
                <div className="multi-currency-unit-title-short">
                    {shortName}
                </div>
                <div className="multi-currency-unit-title-long">{longName}</div>
            </div>
            <div className="multi-currency-selector-dropdown-trigger__arrow-container">
                {showUpArrow ? arrowUp : null}
                {showDownArrow ? arrowDown : null}
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/multi-currency/multi-currency-dropdown-label.jsx